var React = require('react');

function PLAYHEADSM (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(.25 .25)"},[React.createElement("circle",{"cx":"14.79","cy":"14.79","r":"14.79","fill":"#f40","stroke":"#000","strokeMiterlimit":"10","strokeWidth":".5","key":0}),React.createElement("path",{"d":"M11.052 7.525v14.537c0 .422.666.633 1.054.335l9.49-7.268a.4.4 0 000-.669l-9.49-7.269c-.39-.302-1.054-.091-1.054.334z","fill":"#fff","key":1})]));
}

PLAYHEADSM.defaultProps = {"width":"30.079","height":"30.08"};

module.exports = PLAYHEADSM;

PLAYHEADSM.default = PLAYHEADSM;
